import api from "./api.ts";

class UserService {
  updateCustomizeSettings(settings) {
    return api.post("/admin/settings/customize", settings);
  }

  updateConfigSettings(settings) {
    return api.post("/admin/settings/config", settings);
  }

  getLicenseStatus() {
    return api.get("/admin/settings/license");
  }

  updateLicenseSettings(settings) {
    return api.post("/admin/settings/license", settings);
  }

  refreshLicenseSettings() {
    return api.get("/admin/settings/license-refresh");
  }

  getSettings() {
    return api.get("/admin/settings");
  }

  getAuthenticationSettings() {
    return api.get("/admin/settings/authentication");
  }

  updateAuthenticationSettings(settings) {
    return api.post("/admin/settings/authentication", settings);
  }

  getAuthenticationSettingsSamlCertDownload(certType: string) {
    return api.get(`/admin/settings/authentication/download?type=${certType}`, {
      responseType: "blob",
    });
  }

  getServerConfigSettings() {
    return api.get("/admin/settings/serverconfig");
  }

  updateServerConfigSettings(settings) {
    return api.post("/admin/settings/serverconfig", settings);
  }

  generateUserSamlKeyCert() {
    return api.post("/admin/settings/generateUserSamlKeyCert");
  }

  generateServerCert() {
    return api.post("/admin/settings/generateServerCert");
  }

  generateAdminSamlKeyCert() {
    return api.post("/admin/settings/generateAdminSamlKeyCert");
  }

  changePassword(oldpw, newpw) {
    const request = {
      ExistingPassword: oldpw,
      NewPassword: newpw,
    };

    return api.post("/password", JSON.stringify(request));
  }

  invalidateAllSessions() {
    return api.delete("/admin/sessions");
  }

  invalidateAllAdminSessions() {
    return api.delete("/admin/adminsessions");
  }

  deleteSession(id) {
    return api.delete("/admin/sessions/" + id);
  }

  deleteAdminSession(id) {
    return api.delete("/admin/adminsessions/" + id);
  }

  // Agents

  getAgents() {
    return api.get("/admin/agents");
  }

  getAgent(id) {
    return api.get("/admin/agents/" + id);
  }

  createAgent(agent) {
    return api.post("/admin/agents", agent);
  }

  updateAgent(id, agent) {
    return api.put("/admin/agents/" + id, agent);
  }

  deleteAgent(id) {
    return api.delete("/admin/agents/" + id);
  }

  // API keys

  getApiKeys() {
    return api.get("/admin/api-keys");
  }

  getApiKey(id) {
    return api.get("/admin/api-keys/" + id);
  }

  createApiKey(key) {
    return api.post("/admin/api-keys", key);
  }

  updateApiKey(id, key) {
    return api.put("/admin/api-keys/" + id, key);
  }

  deleteApiKey(id) {
    return api.delete("/admin/api-keys/" + id);
  }

  // Backends

  getBackends() {
    return api.get("/admin/backends");
  }

  createBackend(backend) {
    return api.post("/admin/backends", backend);
  }

  updateBackend(id, backend) {
    return api.put("/admin/backends/" + id, backend);
  }

  deleteBackend(id) {
    return api.delete("/admin/backends/" + id);
  }

  // ACLs

  getAcls() {
    return api.get("/admin/acls");
  }

  getAcl(id) {
    return api.get("/admin/acls/" + id);
  }

  createAcl(acl) {
    return api.post("/admin/acls", acl);
  }

  updateAcl(id, acl) {
    return api.put("/admin/acls/" + id, acl);
  }

  deleteAcl(id) {
    return api.delete("/admin/acls/" + id);
  }

  // Knocs

  getKnocs() {
    return api.get("/admin/knocs");
  }

  getKnoc(id) {
    return api.get(`/admin/knocs/${id}`);
  }

  addTestGrant(knocId, data) {
    return api.post(`/admin/knocs/${knocId}/adminaccess`, data);
  }

  // Groups

  getGroups() {
    return api.get("/admin/groups");
  }

  getGroup(id) {
    return api.get("/admin/groups/" + id);
  }

  createGroup(group) {
    return api.post("/admin/groups", group);
  }

  updateGroup(id, group) {
    return api.put("/admin/groups/" + id, group);
  }

  deleteGroup(id) {
    return api.delete("/admin/groups/" + id);
  }

  // Users

  getUsers() {
    return api.get("/admin/users");
  }

  createUser(user) {
    return api.post("/admin/users", user);
  }

  updateUser(id, user) {
    return api.put("/admin/users/" + id, user);
  }

  deleteUser(id) {
    return api.delete("/admin/users/" + id);
  }

  resetOtp(id) {
    return api.delete("/admin/users/" + id + "/totpToken");
  }

  getUserSessions(id) {
    return api.get("/admin/users/" + id + "/sessions");
  }

  getUserGroups(id) {
    return api.get("/admin/users/" + id + "/groups");
  }

  getUserAcls(id) {
    return api.get("/admin/users/" + id + "/acls");
  }

  // Admins

  getAdmins() {
    return api.get("/admin/admins");
  }

  createAdmin(admin) {
    return api.post("/admin/admins", admin);
  }

  updateAdmin(id, admin) {
    return api.put("/admin/admins/" + id, admin);
  }

  deleteAdmin(id) {
    return api.delete("/admin/admins/" + id);
  }

  resetAdminOtp(id) {
    return api.delete("/admin/admins/" + id + "/totpToken");
  }

  getAdminSessions(id) {
    return api.get("/admin/admins/" + id + "/sessions");
  }

  // Audit Logs

  getAuditLogs() {
    return api.get("/admin/logs");
  }
}

export default new UserService();
